var map = {
	"./First Year Recruitment.jpg": 94630,
	"./Hack The Student Life.jpg": 15782,
	"./MakeUofT 2023.jpg": 26790,
	"./MakeUofT 2024.jpg": 20141,
	"./NewHacks 2022.jpg": 49347,
	"./NewHacks 2023.jpg": 68294,
	"./React Workshop.jpg": 58417,
	"./Technical Interview Night.jpg": 53099,
	"./Workshops.jpg": 91259
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 22918;